import { dispatcher, ingenuity } from "@quest/base-core";
import { GameIntroController } from "@quest/murka-games-behavior-panther/dist"
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotEventConstants } from "@quest/slot-core";
import { GameParserModel } from "../Platform/GameParserModel";
// import { SlotEventConstants } from "@quest/slot-core";
export class GameIntroControllerGame extends GameIntroController {

    protected bindContinueButton(): void {
        super.bindContinueButton();
        dispatcher.fireEvent(eventDispatchers.SHOW_POSTLOADING_VIEW);
    }
    protected onContinuePressUp(): void {
        super.onContinuePressUp();
        let collectData = (ingenuity.parserModel as GameParserModel).getCollectMeterData()
        if (!ingenuity.configData.isBrokenGame && !collectData) {
            dispatcher.fireEvent(eventDispatchers.DISPLAY_BANNER_SCREEN);
            dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        }
    }
}
